<div class="user-detail-view-container">
  <div class="header">
    <ng-container>
      <span *ngIf="!_user?.id">New User</span>
      <span *ngIf="_user?.id">Edit User</span>
    </ng-container>
    <i class="material-icons" saAutomatedSelector="user-group__close-button" (click)="closeClicked()">close</i>
  </div>
  <div class="detail-content">
    <div class="content-header">User Info</div>

    <div class="user-inputs-container">
      <ng-container *ngFor="let field of editableUserFields; let i = index">
        <ng-container *ngIf="field.fieldName !== 'email'; else emailInput">
          <sa-detail-view-input
            #detailInput
            [label]="field.label"
            [type]="field.type"
            [value]="_user[field.fieldName]"
            [optional]="field.optional"
            (onValueUpdated)="updateUser(field.fieldName, $event, i)"
          >
          </sa-detail-view-input>
        </ng-container>
        <ng-template #emailInput>
          <sa-detail-view-input
            #detailInput
            [disabled]="this._user.id !== undefined"
            [label]="field.label"
            [type]="field.type"
            [value]="_user[field.fieldName]"
            [optional]="field.optional"
            (onValueUpdated)="updateUser(field.fieldName, $event, i)"
          >
          </sa-detail-view-input>
        </ng-template>
      </ng-container>

      <div class="detail-view-input-container">
        <div class="flex flex-col">
          <div class="form-field-label">Role</div>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="_user.role" placeholder="Select Role" (ngModelChange)="changePermission()">
              <mat-option *ngFor="let role of roles | featureFlag | async" [value]="role.server">{{
                role.value
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="!userService.isSandmanAccount()">
          <div class="help-text" *ngIf="isTruckingVendor">
            Admin users have access to all wells, can create wells, and can invite new users. Standard and View Only
            users only have access to wells where they are added to the “Subscribed Users” list.
          </div>
          <div class="help-text" *ngIf="!isTruckingVendor">
            <strong>Admin</strong> users can login to sandilite.vorto.ai to invite new users, remove users and create
            and manage wells.<br />
            <strong>Standard</strong> users can login to sandilite.vorto.ai to create and edit orders for wells they are
            a subscribed user to but will not have the ability to edit wells.<br />
            <strong>View Only</strong> users can login to sandilite.vorto.ai and only view wells they are a subscribed
            user to.
          </div>
        </ng-container>
      </div>
      <ng-container>
        <div class="spacer">
          <mat-divider></mat-divider>
        </div>
        <div class="detail-view-input-container">
          <div class="detail-view-input flex flex-col">
            <div class="form-field-label">Segment</div>
            <mat-form-field appearance="outline">
              <mat-select [(ngModel)]="_user.segment" (ngModelChange)="changeSegment()">
                <mat-option *ngFor="let segment of segments$ | async" [value]="segment.id">{{
                  segment.name | titlecase
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
      <div class="spacer">
        <mat-divider></mat-divider>
      </div>
      <ng-container *ngIf="permissions?.length > 0">
        <div class="detail-view-input flex flex-col">
          <div class="form-field-label">Additional User Permissions</div>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="permissionsFormControl" multiple>
              <mat-option *ngFor="let permission of permissions" [value]="permission">{{
                getPermissionPrettyName(permission)
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>

      <div class="detail-view-input-container" *ngIf="!_user?.id" style="margin-top: 24px;">
        <div class="detail-view-input flex flex-col">
          <div class="form-field-label">Password</div>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="_user.password" type="password" minlength="6" />
            <mat-hint>
              Minimum 6 characters
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <ng-container *ngIf="_user?.id">
      <div class="content-header">Danger Zone</div>
      <div class="danger-zone">
        Removing this user will prevent them from having access to the {{ _user?.account.name || 'current' }} account.
      </div>

      <button mat-flat-button color="warn" type="button" (click)="removeUser(_user?.id)">
        Remove User
      </button>
    </ng-container>

    <ng-container *ngIf="!_user?.id">
      <button
        mat-flat-button
        color="accent"
        type="button"
        (click)="inviteUser()"
        [disabled]="buttonDisabled || !isFormValid()"
      >
        Invite User
      </button>
    </ng-container>
  </div>
</div>
